import { useEffect, useState } from 'react';
import { API_ENDPOINTS } from '../../config/constants';

interface NewsHeadline {
  title: string;
  url: string;
  source: string;
}

const HeadlineList = ({
  items,
  offset,
}: {
  items: NewsHeadline[];
  offset: number;
}) => (
  <>
    {items.map((item, i) => (
      <a
        key={`${item.url}-${offset}-${i}`}
        href={item.url}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center mx-4 md:mx-10 text-xs md:text-base text-white/70 hover:text-white transition-colors flex-shrink-0"
      >
        <span className="font-bold text-white/90 mr-1.5 md:mr-2.5">
          {item.source}
        </span>
        {item.title}
        <span className="mx-4 md:mx-10 text-white/20">&#x2022;</span>
      </a>
    ))}
  </>
);

const NewsTicker = () => {
  const [headlines, setHeadlines] = useState<NewsHeadline[]>([]);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await fetch(API_ENDPOINTS.newsHeadlines);
        if (!res.ok) return;
        const json = await res.json();
        if (json.success && json.data?.length) {
          setHeadlines(json.data);
        }
      } catch {
        // silently fail — ticker just won't render
      }
    };

    fetchNews();
    const interval = setInterval(fetchNews, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  if (!headlines.length) return null;

  return (
    <div className="bg-[#0a0f1a] overflow-hidden h-10 md:h-14 flex items-center">
      {/* LIVE label */}
      <div className="flex-shrink-0 flex items-center gap-2 md:gap-3 px-3 md:px-6 border-r border-white/10">
        <span className="relative flex h-2 w-2 md:h-3 md:w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 md:h-3 md:w-3 bg-red-500" />
        </span>
        <span className="text-[10px] md:text-sm font-bold text-white uppercase tracking-wider">
          Live
        </span>
      </div>

      {/* Scrolling headlines — two identical copies side by side */}
      <div className="relative flex-1 overflow-hidden">
        <div className="flex animate-ticker whitespace-nowrap">
          <HeadlineList items={headlines} offset={0} />
          <HeadlineList items={headlines} offset={1} />
        </div>
      </div>
    </div>
  );
};

export default NewsTicker;
